export default __webpack_public_path__ + "static/media/pin_blue.f2bac082.svg";